import useSWR, { trigger } from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";
import { setConnected } from "../../utils/date";

const parseMqttJson = (raw) => {
  if (!raw) return null;
  try {
    return JSON.parse(
      raw
        .replace(/'/g, '"')
        .replace(/"\[{"/g, '[{"')
        .replace(/}]",/g, "}],")
        .replace(/}]}"/g, "}]"),
    );
  } catch {
    return null;
  }
};

const eklok = (token, id) =>
  Manager.client(token).get(`${Endpoints.eklok.ekloks}${id}/`);
const ekloks = (token) => Manager.client(token).get(Endpoints.eklok.ekloks);
const createEklok = (token, values) =>
  Manager.client(token).post(Endpoints.eklok.create, values);
const updateEklok = (token, values) =>
  Manager.client(token).post(Endpoints.eklok.update, values);
const refreshEkloks = (token) =>
  trigger(`${Endpoints.eklok.ekloks}/${token.access}`);
const refreshEklok = (token, id) =>
  trigger(`${Endpoints.eklok.ekloks}/${token.access}/${id}`);
const pairEklok = (token, values) =>
  Manager.client(token).post(Endpoints.eklok.pair, values);
const updateStatus = (token, ids) =>
  Manager.client(token).post(Endpoints.eklok.updateStatus, { ekloks: ids });
const activationEklok = (token, id) =>
  Manager.client(token).post(Endpoints.eklok.activation, { eklok: id });
const otpEklokSupport = (token, id) =>
  Manager.client(token).post(Endpoints.eklok.otpSupport, { eklok: id });

const deleteEklok = (token, values) =>
  Manager.client(token).delete(`${Endpoints.eklok.delete}${values.eklok}/`);

export const UseUpdateEkloks = ({ access }, content) => {
  const { data } = useSWR(
    content ? `${Endpoints.eklok.updateStatus}/${access}` : null,
    () =>
      updateStatus(
        access,
        content.data.data.map((item) => item.id),
      ),
    {
      refreshInterval: 5 * 60 * 1000,
    },
  );

  return data;
};

export const UseEkloks = ({ access }) => {
  const { data, error } = useSWR(
    `${Endpoints.eklok.ekloks}/${access}`,
    () => ekloks(access),
    { refreshInterval: 5000 },
  );

  return {
    content: data
      ? data.data.data.map((item) => ({
          ...item,
          connected: undefined,
          last_mqtt_json: parseMqttJson(item.last_mqtt_json),
          alarm_list: parseMqttJson(item.alarm_list),
        }))
      : [],
    error,
    loading: !error && !data,
  };
};

export const UseEklok = ({ access }, id) => {
  const { data, error } = useSWR(
    id ? `${Endpoints.eklok.ekloks}/${access}/${id}` : null,
    () => eklok(access, id),
  );

  return {
    content: data
      ? {
          ...data.data.data,
          connected: data.data.data.last_mqtt_update
            ? setConnected(data.data.data.last_mqtt_update)
            : false,
          last_mqtt_json: parseMqttJson(data.data.data.last_mqtt_json),
          alarm_list: parseMqttJson(data.data.data.alarm_list),
        }
      : null,
    error,
    loading: !error && !data,
  };
};

const updateReleStatus = (token, data) =>
  Manager.client(token).post(Endpoints.eklok.updateReleStatus, data);

export const Request = {
  ekloks,
  createEklok,
  updateEklok,
  refreshEkloks,
  refreshEklok,
  pairEklok,
  updateStatus,
  activationEklok,
  otpEklokSupport,
  deleteEklok,
  updateReleStatus,
};
